// formatMessage fills {name} placeholders and ICU plurals (specs 28 §5):
// "{n, plural, one {# file} other {# files}}" — Arabic messages can use all
// six forms (zero, one, two, few, many, other). # is the number.
const pluralRules = new Map<string, Intl.PluralRules>();
export function formatMessage(s: string, vars: Record<string, string | number> | undefined, locale: string): string {
  if (!vars) return s;
  if (s.includes(", plural,")) s = plurals(s, vars, locale);
  for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v));
  return s;
}

function plurals(s: string, vars: Record<string, string | number>, locale: string): string {
  let out = "";
  let i = 0;
  while (i < s.length) {
    const start = s.indexOf("{", i);
    if (start < 0) { out += s.slice(i); break; }
    const m = /^\{(\w+), plural,/.exec(s.slice(start));
    // A plain {placeholder} before a plural: keep it, look further.
    if (!m) { out += s.slice(i, start + 1); i = start + 1; continue; }
    out += s.slice(i, start);
    // Find the matching closing brace of this plural block.
    let depth = 0, end = start;
    for (; end < s.length; end++) {
      if (s[end] === "{") depth++;
      else if (s[end] === "}" && --depth === 0) break;
    }
    const body = s.slice(start + m[0].length, end);
    const n = Number(vars[m[1]] ?? 0);
    const forms: Record<string, string> = {};
    for (const f of body.matchAll(/(=\d+|zero|one|two|few|many|other)\s*\{((?:[^{}]|\{[^{}]*\})*)\}/g)) forms[f[1]] = f[2];
    let rules = pluralRules.get(locale);
    if (!rules) { rules = new Intl.PluralRules(locale); pluralRules.set(locale, rules); }
    const text = forms[`=${n}`] ?? forms[rules.select(n)] ?? forms.other ?? "";
    out += text.replaceAll("#", new Intl.NumberFormat(locale === "en" ? "en" : `${locale}-u-nu-latn`).format(n));
    i = end + 1;
  }
  return out;
}

